import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import "../Login.css";

function Login() {
  const { login, resetPassword } = useAuth(); // เพิ่ม resetPassword จาก AuthContext
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [showReset, setShowReset] = useState(false);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  const [regUsername, setRegUsername] = useState("");
  const [regPassword, setRegPassword] = useState("");
  const [regEmail, setRegEmail] = useState("");
  const [regFullname, setRegFullname] = useState("");
  const [regError, setRegError] = useState("");
  const [regMessage, setRegMessage] = useState("");
  const handleLogin = async () => {
    const success = await login(username, password);
    if (success) {
      // User ยังไม่มี Email
      if (!success.email) {
        navigate("/add-email", {
          state: {
            fullname: success.fullname,
            idvender: success.idvender,
            userinuse: success.userinuse,
          },
        });

        return;
      }

      // มี Email แล้ว
      navigate("/welcome", {
        state: {
          fullname: success.fullname,
          idvender: success.idvender,
          userinuse: success.userinuse,
          email: success.email,
          wherefrm: success.wherefrm,
        },
      });
    } else {
      setError("Invalid username or password");
    }
  };

  const handleResetPassword = async () => {
    if (!email) {
      setError("Please enter your email.");
      return;
    }
    try {
      const success = await resetPassword(email);
      if (success) {
        setMessage(
          "password reset link has been sent to your email. Please reset within 10 minutes.",
        );
        setError("");
      } else {
        setError("Email not found or unable to send reset link.");
      }
    } catch (err) {
      setError("An error occurred while sending reset email.");
    }
  };

  const handleRegister = async () => {
    try {
      if (!regUsername || !regPassword || !regEmail) {
        setRegError("Please fill all required fields");
        return;
      }

      const res = await fetch("/api/auth/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: regUsername,
          password: regPassword,
          email: regEmail,
          fullname: regFullname,
        }),
      });

      const data = await res.json();

      if (data.success) {
        setRegMessage("Register success! Please login.");
        setRegError("");

        setRegUsername("");
        setRegPassword("");
        setRegEmail("");
        setRegFullname("");
      } else {
        setRegError(data.message || "Register failed");
      }
    } catch (err) {
      setRegError("Server error");
    }
  };
  return (
    <div className="login-container">
      <div className="login-box">
        <img
          src="assets/logo.png"
          alt="Company Logo"
          className="logo"
          style={{ width: "150px", marginBottom: "1px" }}
        />
        <h1 className="portal-title">Supplier Portal</h1>

        <h2>{showReset ? "Reset Password" : "Login"}</h2>

        {!showReset ? (
          <>
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <input
                id="username"
                type="text"
                placeholder="Enter your username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="form-group" style={{ position: "relative" }}>
              <label htmlFor="password">Password</label>

              <input
                id="password"
                type={showPassword ? "text" : "password"} // ⭐ จุดสำคัญ
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleLogin();
                  }
                }}
                // style={{ paddingRight: "40px" }} // กัน icon ทับ
              />

              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "70%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#555",
                  userSelect: "none",
                }}
              >
                {/* {showPassword ? "👁️" : "🚫"} */}
                {showPassword ? "👁" : "👁‍🗨"}
              </span>
            </div>
            {error && <p className="error-message">{error}</p>}
            <button className="login-button" onClick={handleLogin}>
              Login
            </button>
            <p className="forgot" onClick={() => setShowReset(true)}>
              Forgot password?
            </p>
            {/* <button
              className="login-button"
              onClick={() => setShowRegister(true)}
            >
              Register
            </button> */}
          </>
        ) : (
          <>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                placeholder="Enter your registered email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            {error && <p className="error-message">{error}</p>}
            {message && <p className="success-message">{message}</p>}
            <button className="login-button" onClick={handleResetPassword}>
              Send Reset Link
            </button>
            <p className="back-to-login" onClick={() => setShowReset(false)}>
              ← Back to Login
            </p>
          </>
        )}
        {showRegister && (
          <>
            <h2>Register</h2>

            <div className="form-group">
              <label>Username</label>
              <input
                value={regUsername}
                onChange={(e) => setRegUsername(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                value={regPassword}
                onChange={(e) => setRegPassword(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={regEmail}
                onChange={(e) => setRegEmail(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Fullname</label>
              <input
                value={regFullname}
                onChange={(e) => setRegFullname(e.target.value)}
              />
            </div>

            {regError && <p className="error-message">{regError}</p>}
            {regMessage && <p className="success-message">{regMessage}</p>}

            <button className="login-button" onClick={handleRegister}>
              Create Account
            </button>

            <p className="back-to-login" onClick={() => setShowRegister(false)}>
              ← Back to Login
            </p>
          </>
        )}
        <div className="login-footer">© 2026 Supplier Portal</div>
      </div>
    </div>
  );
}

export default Login;
